import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  clientFilter,
  clients,
  date,
  setDate,
  setClientFilter,
  applyFilters,
  removeFilters,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Control
            as="select"
            value={clientFilter || ""}
            onChange={(e) => setClientFilter(e.target.value)}
          >
            <option value="">All Clients</option>

            {clients
              ?.filter((client) => client.status === "Active")
              .map((client) => (
                <option key={client._id} value={client.name}>
                  {client.name}
                </option>
              ))}
          </Form.Control>

          <Form.Group controlId="dateFilter">
            <Form.Label>
              <b>Date</b>
            </Form.Label>
            <Form.Control
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              max={new Date().toISOString().split("T")[0]}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
